export const BUTTON_LABELS = {
  createMore: 'Create more',
  createFullscreen: 'Open issue creation in fullscreen',
  create: 'Create',
  cancel: 'Cancel',
}
